export default __webpack_public_path__ + "static/media/sh-shield.12e1f314.svg";